import compose from 'utils/composeEnhancer'
import useRedirect from './useRedirect'

export default compose(useRedirect)
